import script from "./WorkspaceMatchModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./WorkspaceMatchModal.vue?vue&type=script&setup=true&lang=ts"

import "./WorkspaceMatchModal.vue?vue&type=style&index=0&id=66de446b&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-66de446b"]])

export default __exports__